import { JetView } from 'webix-jet'; // Importing JetView from the webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing the deposit report view.
 * @extends JetView
 */
export default class tableDepositReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Define the date format based on the application configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Get the current user parameter from the request
        const cur_user = this.getParam('user', true);
        // Extend the summTreeColumn filter to include custom refresh logic
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                /**
                 * Refreshes the display of the summary tree column.
                 * @param {Object} master - The master view containing the data.
                 * @param {Object} node - The node to update.
                 * @param {Object} value - The value object containing columnId.
                 */
                refresh: function (master, node, value) {
                    var result = 0; // Initialize the result variable for summation
                    var resultFormat = 0; // Initialize the formatted result variable
                    // Iterate through each data object in the master view
                    master.data.each(function (obj) {
                        // Sum values for objects at level 1
                        if (obj.$level == 1) result += obj[value.columnId];
                    });
                    // Format the result based on the columnId
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    // Update the inner HTML of the node with the formatted result
                    node.firstChild.innerHTML = resultFormat;
                },
            },
            webix.ui.datafilter.summColumn, // Extend from the existing summColumn filter
        );
        // Return the configuration for the UI component
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'treetable', // Define a tree table view
                            id: 'treetable', // ID for the tree table
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            scheme: {
                                $group: {
                                    by: 'UserName', // Grouping by UserName
                                    map: {
                                        UserName: ["<span style='font-weight:bold;'>Total:</span>", 'string'],
                                        Amount: ['Amount', 'sum'], // Summation for Amount
                                        WinningAmount: ['WinningAmount', 'sum'], // Summation for WinningAmount
                                    },
                                },
                            },
                            select: true, // Enable row selection
                            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
                            height: screen.width < 820 ? 405 : 405, // Set height based on screen width
                            columns: [
                                {
                                    id: 'UserName', // Column ID for UserName
                                    header: _('UserName'), // Header text for UserName
                                    width: 200, // Width of the column
                                    /**
                                     * Template function to display UserName or group label.
                                     * @param {Object} obj - The data object.
                                     * @param {Object} common - Common methods for the column.
                                     * @returns {string} - HTML string for the cell.
                                     */
                                    template: function (obj, common) {
                                        if (obj.$group) return common.treetable(obj, common) + obj.value; // Return group label
                                        return obj.UserName; // Return UserName
                                    },
                                },
                                {
                                    id: 'detailTittle', // Column ID for detail title
                                    header: '', // No header for this column
                                    width: 50, // Width of the column
                                    height: 25, // Height of the column
                                    tooltip: _('Detalles'), // Tooltip text
                                    /**
                                     * Template function to display detail icon based on level.
                                     * @param {Object} obj - The data object.
                                     * @returns {string} - HTML string for the cell.
                                     */
                                    template: function (obj) {
                                        if (obj.$level == 1) {
                                            return ''; // No icon for level 1
                                        } else {
                                            if (obj.$level == 2) {
                                                return "<span class='webix_icon wxi-close details'></span>"; // Detail icon for level 2
                                            }
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID for ID
                                    header: 'ID', // Header text for ID
                                    width: 70, // Width of the column
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ClientId', // Column ID for Client ID
                                    header: _('ID Usuario'), // Header text for Client ID
                                    width: 95, // Width of the column
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CreatedLocal', // Column ID for creation date
                                    header: _('Fecha de Creación'), // Header text for creation date
                                    fillspace: 0, // No fill space
                                    minWidth: 0, // Minimum width
                                    width: 150, // Width of the column
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date format for display
                                },
                                {
                                    id: 'PaymentSystemName', // Column ID for payment system name
                                    header: _(
                                        'Nombre del sistema de pasarela de pago', // Header text for payment system name
                                    ),
                                    width: 300, // Width of the column
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'TypeName', // Column ID for type name
                                    header: _('Tipo'), // Header text for type name
                                    width: 100, // Width of the column
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CurrencyId', // Column ID for currency
                                    header: _('Moneda'), // Header text for currency
                                    width: 100, // Width of the column
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Amount', // Column ID for amount
                                    header: _('Valor'), // Header text for amount
                                    width: 100, // Width of the column
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Format for displaying price
                                    exportType: 'number', // Export type for amount
                                    editor: 'text', // Editor type for inline editing
                                },
                                {
                                    id: 'ModifiedLocal', // Column ID for modified date
                                    header: _('Modificado'), // Header text for modified date
                                    fillspace: 0, // No fill space
                                    minWidth: 0, // Minimum width
                                    width: 150, // Width of the column
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date format for display
                                },
                                {
                                    id: 'State', // Column ID for state
                                    header: _('Estado'), // Header text for state
                                    options: [
                                        // Options for state dropdown
                                        { id: '', value: _('None') },
                                        { id: 'A', value: _('Pagada') },
                                        { id: 'C', value: _('Cancelado') },
                                        { id: 'I', value: _('Inactivo') },
                                        { id: 'R', value: _('Rechazada') },
                                    ],
                                },
                                {
                                    id: 'ExternalId', // Column ID for external ID
                                    header: 'External ID', // Header text for external ID
                                    width: 150, // Width of the column
                                    sort: 'int', // Sorting type
                                },
                            ],
                            // Event handler for clicking on detail icon
                            onClick: {
                                details: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('deposit:id', [
                                        item.Id, // Trigger event with item ID
                                    ]);
                                    // Show filter details if screen size is small
                                    if (screen.width < 500 || screen.height < 500) {
                                        $$('filterDetails').show();
                                    }
                                },
                            },
                            tooltip: true, // Enable tooltips
                            footer: false, // Disable footer
                            math: true, // Enable mathematical operations
                            loadahead: 0, // Set load ahead for data fetching
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerA', // ID for the pager component
                            leftSplit: screen.width > 500 ? 1 : 0, // Conditional left split based on screen width
                        },
                    ],
                },
            ],
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Initialize the grid component for the tree table
        grid = $$('treetable');

        // Retrieve the current user parameter from the application context
        const cur_user = this.getParam('user', true);

        // Construct the API URL for fetching deposits and withdrawals with paging
        var url = devConfig.geturlApi() + 'es/Financial/GetDepositsWithdrawalsWithPaging2?FromId=' + cur_user + '&';

        // Initialize an empty filter string
        var filter = '';

        // Set up an event listener for the 'depositReport:filter' event
        this.on(this.app, 'depositReport:filter', (filterData) => {
            // Convert filterData object into an array of entries
            var object = Object.entries(filterData);
            var string1 = '';

            // Iterate over each entry in the filter data
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and not empty
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle date range selection from the datepicker
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        // Handle other filter fields except 'Date'
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        } else {
                            // Handle single date selection
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    // Handle cases where the value is an object (e.g., date range)
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle start date
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    // Handle end date
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Append the current user ID to the filter string
            string1 = string1 + '&FromId=' + cur_user;

            // Clear the grid data before loading new data
            grid.clearAll();

            // Load the grid with the constructed URL and filter parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);

            // Hide the filter popup after applying the filter
            $$('filterPopup').hide();

            // Update the filter variable with the current filter string
            filter = string1;
        });

        // Attach an event listener for sorting the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Load the grid with the sorted data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir);
        });

        // Set up an event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            // Load the grid with data for the selected player
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + user);
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
